export const RESET = 'EXSBWAREHOUSEITEM_LIST_RESET'
export const SET_ITEMS = 'EXSBWAREHOUSEITEM_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBWAREHOUSEITEM_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBWAREHOUSEITEM_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBWAREHOUSEITEM_LIST_TOGGLE_LOADING'
